import { Observable } from "rxjs/Observable";
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { ModalPopupService } from "./modal-popup.service";
import { Injectable } from "@angular/core";

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

    canDeactivate(
        component: CanComponentDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate()
    };
}

@Injectable()
export class CanDeactivateGuardService {
    constructor(private modalPopupService: ModalPopupService) {
    }
    
    getCanDeactivateResult() {
        if (this.modalPopupService.getChangeDetected()) {
            this.modalPopupService.openModal();
            return this.modalPopupService.getResult();
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-popup/can-deactivate-gaurd.service.ts